//Español
export default {
	userDrawer:{
		data:[
			{name:'Inicio'},
			{name:'Buscar'},
			{name:'Categoría'},
			{name:'Carrito'},
			{name:'Mis Favoritos'},
			{name:'Mi cuenta'},
			{name:'Idioma'}
		],
		language:[
			{name:'Chino'},
			// {name:'Inglés'},
			// {name:'Francés'},
			// {name:'Tailandés'},
			// {name:'Laosiano'},
			{name:'Español'},
		]
	},
	order:{
		invoiceInfo: 'Información de la factura',
		invoiceType: 'Tipo de factura',
		generalInvoice: 'Factura general',
		specialInvoice: 'Factura especial',
		invoiceTip: 'Las facturas electrónicas ordinarias tienen la misma validez legal que las facturas en papel y pueden utilizarse para reembolso, servicio posventa y comprobantes de mantenimiento. El uso de facturas electrónicas ordinarias es ilimitado, más conveniente y respetuoso con el medio ambiente.',
		invoiceHeader: 'Encabezado de factura',
		personal: 'Personal',
		company: 'Empresa',
		inputPersonalHeader: 'Por favor, ingrese el encabezado de la factura',
		inputCompanyHeader: 'Por favor, ingrese el nombre de la empresa',
		inputDutyNumber: 'Por favor, ingrese el número de identificación fiscal',
		inputDutyNumberWarn: 'Por favor, ingrese el número de identificación fiscal',
		email: 'Correo electrónico',
		inputEmail: 'Por favor, ingrese el correo electrónico',
		inputEmailWarn: 'Por favor, ingrese un correo electrónico válido',
		inputHeaderNameWarn: 'Por favor, ingrese el encabezado de la factura',
		save: 'Guardar',
		cancel: 'Cancelar',
		submitting: 'Enviando...',
		invoiceDetail: 'Detalles de la factura',
		headerType: 'Tipo de encabezado',
		taxNumber: 'Número de identificación fiscal',
		invoiceAmount: 'Monto de la factura',
		invoiceStatus: 'Estado de la factura',
		applyTime: 'Tiempo de aplicación',
		invoiceImage: 'Imagen de la factura',
		clickToPreview: 'Haga clic para ver la imagen completa',
		close: 'Cerrar'
	},
	page:{
		index:{
			navTitle:'Inicio',
			mainNav:[
				{name:'Categorías'},
				{name:'Favorito'},
				{name:'Pedido'},
				{name:'Dirección'},
			],
			coupons:'Cupones',
			titProduct:'Productos destacados',
			titNow:'Tendencias actuales',
			titCate:'Categorías destacadas',
			titBtn:'Ver todo',
			titAlso:'También te puede interesar',
			couponDesc:'Pedido superior a US ',
			received:'Recibido',
			orMore:'o más',
			viewDetails:'Detalles',
			trackOrder: 'rastrear pedido',
			recommended: 'Recomendado',
			promotions: 'Promociones',
			onView:'Ver artículo',
			collectSite: 'Coleccionar este sitio',
			applyFor: 'Solicitar',
			mobileMall: 'Centro comercial móvil',
			shopStreet: 'CALLE DE TIENDAS',
			customerService: 'Servicio',
			top: 'Arriba',
			topOne: 'TOP UNO',
			footer1: 'Variedad completa',
			footer2: 'Entrega rápida',
			footer3: 'Producto genuino',
			footer4: 'Precio bajo todos los días',
			address: "Habitación 1101-04, Bloque A, Plaza Qihang Times, Avenida Xixian, Distrito de Weiyang, Ciudad de Xi'an, Provincia de Shaanxi",
			icp: "Xi'an Zhongbang Network Technology Co., Ltd. Shaanxi ICP No. 14011498-3",
			aboutUs: 'Sobre nosotros',
			contactUs: 'Contáctenos',
			userAgreement: 'Acuerdo de usuario'
		},
		news: {
			navTitle: 'Noticias',
			sidebarTitle: 'Noticias Populares',
			news: 'Noticias'
		},
		trackOrder: {
			tips: 'Para rastrear su pedido, ingrese su ID de pedido en el cuadro a continuación y presione el botón "Rastrear". Esto se le proporcionó en su recibo y en el correo electrónico de confirmación que debería haber recibido.',
			title: 'Rastrear pedido',
			orderId: 'ID de pedido',
			email: 'Correo electrónico',
			btnTxt: 'Rastrear',
			successTip: 'Consulta exitosa, se ha enviado a su correo electrónico'
		},
		goodsDetail:{
			search:'Buscar productos',
			sales:'Ventas',
			oldPrice:'Precio anterior',
			inventory:'Inventario',
			coupons:'cupones',
			choose:'elegir',
			choose1:'elección',
			Reviews:'Opiniones',
			good:'Bueno',
			details:'Detalles',
			recommend:'Recomendar',
			home:'Inicio',
			like:'Me gusta',
			cart:'Carrito',
			addCart:'Añadir al carrito',
			buyNow:'Comprar ahora',
			soldOut:'Agotado',
			sold: 'Vendido',
			type:'tipos en total',
			navList:[
				{name:'producto'},
				{name:'opinión'},
				{name:'recomendar'},
				{name:'detalle'},
				{name:'atributo'}
			],
			spec:'Especificación',
			select:'El seleccionado',
			clear:'Eliminar todo',
			settle:'Liquidar',
			num:'Número',
			confirm:'Confirmar',
			cancel: 'Cancelar',
			edit: 'Editar',
			save: 'Guardar',
			submit: 'Enviar',
			assure:"Asegurar",
			guarantee: [
				{name: 'Garantía de producto genuino', icon: '', content: 'Todos los productos son originales de fábrica, con etiquetas anti-falsificación y códigos de rastreo únicos, 100% garantía de autenticidad.'},
				{name: 'Devolución sin motivo en 7 días', icon: '', content: 'Admite devolución sin motivo en 7 días sin afectar la reventa.'}
			],
			ratingLabels: {
				productScore: 'Calificación del producto',
				descriptionMatch: 'Descripción coincidente',
				serviceAttitude: 'Actitud de servicio',
				deliveryService: 'Servicio de entrega'
			}
		},
		goodsList:{
			navTitle:'Lista de productos',
			search:'Buscar productos',
			default:'Por defecto',
			price:'Precio',
			sales:'Ventas',
			new:'Nuevo',
			empty:'Ve a ver otra cosa',
			no: 'No más',
			more: 'Cargar más',
			nono: 'También tengo un límite',
			nomer: 'Ninguna tienda'
		},
		user:{
			navTitle:'Mi cuenta',
			user:'Usuario',
			like:'Lista de deseos',
			integral:'integral',
			coupons:'Cupones',
			orderCenter:'Centro de pedidos',
			myOrder:'Mi pedido',
			placeLogin:'Por favor, haga clic para iniciar sesión',
			orderStatus:[
				{name:'Por pagar'},
				{name:'En espera'},
				{name:'Recibido'},
				{name:'Evaluación'},
				{name:'Devolución'},
				{name:'Completado'},
				{name:'Mercancía recibida'}
			],
			services:'Otros servicios',
			address:'Gestión de direcciones',
			contact:'Servicio al cliente',
			applicationRecord: 'Colección de comerciantes',
			goodsCollection: 'Colección de productos',
			profile: 'Información personal',
      		service: 'Servicio postventa',
			record: 'Registro de solicitud',
			mineNav: [
				{name: 'Mi pedido'},
				{name: 'Lista de reembolsos'},
				{name: 'Lista de evaluaciones'},
				{name: 'Billetera'}
			],
			qunTitle: 'Información de la licencia comercial',
			qunDesc: 'De acuerdo con los requisitos de la Administración Estatal de Industria y Comercio "Medidas de gestión de transacciones en línea", la información de la licencia comercial de la tienda en línea se publica de la siguiente manera:',
			qunCode: 'Por favor, ingrese el código de verificación de la imagen',
			submit: 'enviar',
		},
		goodsSearch:{
			navTitle:'Búsqueda de productos',
			place:'Haga clic para buscar productos',
			search:'Buscar',
			hotSearch:'Búsqueda popular',
			recommend:'recomendar',
			emptySearch:'No hay nada',
			placeSearch:'Por favor, ingrese el artículo a buscar',
			onSearch:'Buscando',
			goods:'productos',
			mer: 'Comerciante',
			merchantType: 'Tipo de comerciante',
			merchantClassify:'Clasificación de comerciantes',
			sure :'determinar',
			reset: 'Restablecer',
			open: 'expandir todo',
			up: 'Guardar',
			sort: 'Ordenar',
			Default: 'por defecto',
			Seller: 'Vendedor',
			Price: 'Precio',
			moreMer: 'más tiendas',
			searchMer: 'Lo sentimos, no se encontró la tienda que buscó~',
			searchGoods: 'Lo sentimos, no se encontró nada relacionado con su búsqueda~',
		},
		goodsAddcart:{
			navTitle:'Carrito de compras',
			labelNav:'100% de garantía de calidad del producto y servicio postventa',
			buyNum:'Comprar cantidad',
			management:'gestión',
			cancel:'cancelar',
			attribute:'especificación',
			failureGoods:'La falla de los bienes',
			empty:'Eliminar todo',
			failure:'falla',
			fallDesc:'Los bienes ya no son válidos',
			selectAll:'Todo',
			buyNow:'Comprar ahora',
			like:'Me gusta',
			delete:'Eliminar',
			emptyCart:'No hay productos',
			again: 'Por favor, vuelva a seleccionar la especificación',
			reselect :'volver a seleccionar',
			productInfo: 'Información del producto',
			unitPrice: 'Precio unitario',
			quantity: 'Cantidad',
			total: 'Total',
			operate: 'Operación',
		},
		orderPayStatus:{
			success:'pago exitoso',
			fail:'Pago fallido',
			orderId:'ID de pedido',
			orderTime:'Hora',
			payType:'Método de pago',
			payPrice:'Pago total',
			failReason:'La razón del fracaso',
			viewOrder:'Para ver el pedido',
			backHome:'Volver a inicio'
		},
		paymentResult:{
			successTip:'Su pedido será enviado lo antes posible',
			failTip:'El pago del pedido falló, por favor vuelva a realizar el pedido',
			confirm:'Confirmar'
		},
		orderDetails:{
			navTitle:'Detalles del pedido',
			item:'artículo(s)',
			Customer:'Servicio al cliente',
			orderId:'ID de pedido',
			copy:'copiar',
			orderTime:'Hora',
			refundTime: 'Tiempo de reembolso',
			payStatus:'Estado de pago',
			payTrue:'Pago exitoso',
			payFalse:'No pagó',
			payType:'Método',
			message:'mensaje',
			name:'Consignatario',
			phone:'Teléfono',
			address:'Dirección',
			selfStore: 'Tienda de recogida',
			storeName: 'Nombre de la tienda',
			contactPerson: 'Persona de contacto',
			contactPhone: 'Teléfono',
			contactEmail: 'Correo electrónico',
			storeAddress: 'Dirección',
			returnReason:'Razón',
			returnMsg:'Descripción',
			returnImg: 'Cupón',
			delivery:'Método de entrega',
			deliveryOne:'Envío',
			deliveryTwo:'Recogida',
			consigneeInfo: 'Información del destinatario',
			consigneeName: 'Destinatario',
			consigneePhone: 'Teléfono de contacto',
			sendMethod:'Método',
			sendOne:'Enviar',
			sendTwo:'La entrega',
			CourierCompany:'NombreExp',
			CourierNo:'NoExp',
			deliveryName:'Mensajero',
			deliveryPhone:'Teléfono',
			Virtual:'Virtual',
			deliveryMsg:'Ha sido enviado',
			allPrice:'Precio total',
			freight:'flete',
			coupon:'Deducción de cupón',
			point:'Deducción de puntos',
			actualPayment:'Pago real',
			cancelOrder:'Cancelar pedido',
			nowPay:'Pagar ahora',
			refund:'Reembolso',
			logistics:'Logística',
			confirm:'Confirmar',
			delete:'Eliminar',
			again:'De nuevo',
			applyInvoice:'Aplicar a la factura',
			confirmInfo: 'Para proteger sus derechos e intereses, confirme la recepción después de recibir los productos y confirmar que son correctos',
		    confirmDel: '¿Está seguro de eliminar este pedido?',
			confirmCancel: 'Confirmar para cancelar el pedido',
			// Formulario de dirección
			formName: 'Nombre del destinatario',
			formEmail: 'Correo electrónico',
			formEmailCode: 'Código de verificación de correo',
			formPhone: 'Teléfono de contacto',
			formPostCode: 'Código postal',
			formRegion: 'Región',
			formAddress: 'Dirección detallada',
			formCreateAccount: '¿Crear cuenta?',
			// Marcadores de posición
			placeholderName: 'Por favor, ingrese el nombre del destinatario',
			placeholderEmail: 'Por favor, ingrese la dirección de correo electrónico',
			placeholderEmailCode: 'Por favor, ingrese el código de verificación',
			placeholderPhone: 'Por favor, ingrese el teléfono de contacto',
			placeholderPostCode: 'Por favor, ingrese el código postal',
			placeholderRegion: 'Por favor, seleccione provincia/ciudad/distrito',
			placeholderAddress: 'Por favor, ingrese la dirección detallada (calle, número, etc.)',
			// Botones
			sendCode: 'Enviar código',
			sendingCode: 'segundos',
			// Consejos de validación
			validateName: 'Por favor, ingrese el nombre del destinatario',
			validateEmail: 'Por favor, ingrese la dirección de correo electrónico',
			validateEmailFormat: 'Por favor, ingrese un formato de correo correcto',
			validateEmailCode: 'Por favor, ingrese el código de verificación',
			validatePhone: 'Por favor, ingrese el teléfono de contacto',
			validatePhoneFormat: 'Por favor, ingrese un número de teléfono correcto',
			validatePostCode: 'Por favor, ingrese el código postal',
			validatePostCodeFormat: 'Por favor, ingrese un código postal de 6 dígitos',
			validateRegion: 'Por favor, seleccione la región',
			validateAddress: 'Por favor, ingrese la dirección detallada',
			validateAddressLength: 'La dirección debe tener al menos 5 caracteres',
			// Consejos de operación
			tipEmailFirst: 'Por favor, ingrese primero la dirección de correo',
			tipEmailInvalid: 'Por favor, ingrese una dirección de correo válida',
			tipCodeSent: 'Código enviado con éxito, por favor revise su correo',
			tipCodeFailed: 'Error al enviar el código, inténtelo más tarde',
			tipFormIncomplete: 'Por favor, complete toda la información de dirección',
			tipSelectRegion: 'Por favor, seleccione la región',
			tipAddressSaved: 'Dirección guardada con éxito',
			tipAddressFailed: 'Error al guardar la dirección, inténtelo más tarde',
			tipConsigneeSaved: 'Información del destinatario guardada con éxito',
			tipContactSaved: 'Información de contacto guardada con éxito',
			tipEnterConsignee: 'Por favor, ingrese el nombre del destinatario',
			tipEnterContact: 'Por favor, ingrese el teléfono de contacto',
			orderRemark: 'Observaciones del pedido',
			postCode: 'Código postal',
			region: 'Región',
		},
		users:{
			userInfo:{
				navTitle:'Configuración',
				avatar:'Avatar',
				name:'Nombre',
				email:'usuario',
				password:'Contraseña',
				save:'Guardar',
				logOut:'Cerrar sesión',
				phone:'Teléfono',
				msg: 'El nombre de usuario no puede estar vacío',
				personalCenter: 'centro personal',
			},
			orderConfirm:{
				setAddress:'Establecer dirección',
				navTitle:'Realizar pedido',
				items:'artículo(s)',
				coupons:'cupones',
				integral:'integral',
				freight:'flete',
				note:'describir',
				payPal:'Pago',
				allPrice:'Cantidad total',
				remaining:' restante',
				newIntegral:'ahora',
				free:'gratis',
				placeNote:'Por favor, agregue comentarios (menos de 150)',
				CouponDeduction:'Deducción de cupón',
				total:'Total',
		        payment: 'Por favor, escanee el código para completar el pago',
		        paymentResults: 'pagado',
		        paymentResultsNo: 'No pagado',
				message:'¿Estás seguro de que quieres pagar esta orden?',
				messageTitle:'Confirmar',
				offlinePaymentInfo: 'Pago por transferencia'
			},
			orderList:{
				navTitle:'Mi pedido',
				orderNum:'Pedido acumulado',
				total:'Consumo total',
				orderStatus:[
					{name:'Por pagar'},
					{name:'En espera'},
					{name:'Recibido'},
					{name:'Evaluación'},
					{name:'Devolución'},
				],
				item:'artículo(s)',
				totalPay:'Pago total',
				cancelOrder:'Cancelar',
				viewDetails:'Ver detalles',
				evaluation:'Evaluación',
				evaluated:'Evaluado',
				delete:'Eliminar',
				empty:'No hay información del pedido',
				pay:'Pago',
				complete:'Completar',
				orderInfo: 'Información del pedido',
				afterSale:'Solicitud de posventa',
			},
			afterSale: {
				navTitle: 'Gestión de posventa',
				tabs: {
					apply: 'Solicitud de posventa',
					processing: 'En proceso',
					completed: 'Procesado'
				},
				buttons: {
					apply: 'Solicitar posventa',
					view: 'Ver detalles',
					cancel: 'Cancelar solicitud',
					fillTracking: 'Ingresar número de seguimiento'
				},
				status: {
					returnGoods: 'Producto pendiente de devolución',
					refundOnly: 'Solo reembolso',
					returnRefund: 'Devolución y reembolso',
					success: 'Reembolso exitoso'
				},
				labels: {
					applyTime: 'Tiempo de solicitud',
					applyStatus: 'Estado de solicitud'
				},
				confirmCancel: '¿Está seguro de que desea cancelar esta solicitud de posventa?',
				cancelSuccess: 'Cancelado con éxito',
				cancelFailed: 'Error al cancelar'
			},
			userCoupon:{
				navTitle:'Mis cupones',
				available:'Disponible',
				expired:'Caducado/Usado',
				min:'Mínimo',
				can:'Usar ahora',
				used:'Caducado',
				general:'General',
				goods:'Productos',
				cate:'Categoría',
				receive:'Obtener',
				received:'Recibido',
				receivedInfo:'Disponible dentro de',
				receivedInfo1:'día después de recibir',
				navList:[
					{name:'negocio'},
					{name:'Productos'},
					{name:'Categoría'},
				],
				empty:'No hay cupones',
				valid:'Válido por',
				day:'día',
		        minus: 'menos',
		        getUsers: 'para usar'
			},
			userGoodsCollection:{
				navTitle:'Mi lista de deseos',
				item:'artículo(s)',
				management:'gestión',
				cancel:'cancelar',
				empty:'No hay colección'
			},
			userAddressList:{
				navTitle:'Dirección',
				default:'Dirección predeterminada',
				add:'Agregar una nueva dirección',
				emptyAddress:'No hay información de dirección',
		        edit:'revisar',
		        del:'eliminar',
		        sureDel: '¿Está seguro de eliminar esta dirección?'
			},
			userAddress:{
				navTitle:'Dirección',
				name:'Nombre',
				Email:'Correo electrónico',
				country:'País',
				address:'Dirección',
				postCode:'Código postal',
				phone:'Teléfono',
				default:'Dirección predeterminada',
				save:'Guardar',
				place:'Por favor, ingrese el ',
        placeRegion: 'Por favor seleccione provincia/ciudad/distrito'
			},
			userReturnList:{
				navTitle:'Lista de devoluciones',
				orderId:'No de pedido de reembolso',
				item:'artículo(s)',
				total:'Pago de reembolso ',
				refunding:'Reembolsando',
				refunded:'Reembolsado',
				examine: 'Revisión comercial en curso',
				examineInfo: 'Ha iniciado con éxito la solicitud de reembolso, espere pacientemente a que el comerciante la procese; negocie con el comerciante antes de reembolsar, lo que ayudará a tratar mejor los problemas de posventa',
				examine1: 'El comerciante ha reembolsado',
				refuse: 'Rechazar reembolso',
				refuseReason: 'Razón del rechazo：',
				refuseReason2: 'El reembolso ha sido aceptado con éxito. Si el comerciante ha enviado productos, devuélvalos lo antes posible; Gracias por su apoyo',
			},
			goodsCommentList:{
				navTitle:'Opinión del producto',
				score:'Puntuación',
				good:'Bueno',
				all:'Todo',
				goodScore:'Bueno',
				general:'General',
				bad:'Malo',
				attribute:'Atributo',
				seller:'vendedor'
			},
			goodsCommentCon:{
				navTitle:'Opinión del producto',
				score:[
					{name:'Calificación por estrellas'},
					{name:'Descripción coincidente'},
					{name:'Actitud de servicio'},
					{name:'Servicio de entrega'}
				],
				place:'¿El producto cumple con sus expectativas? Comparta sus ideas con aquellos que quieran comprar' ,
				upload:'Subir',
				submit:'Enviar',
				tips: 'Gracias por sus comentarios',
				tipsWrite: '¡Por favor, complete su experiencia con el bebé!',
		        SU: 'Evaluación exitosa',
		        tipsSU:'Continuaremos brindándole mejores productos y servicios'
			},
			goodsReturn:{
				navTitle:'Solicitud de devolución',
				number:'Número',
				price:'Dinero',
				reason:'Razón',
				info:'observación',
				voucher:'Subir certificado',
				place:'notas adicionales para el vendedor (máx. 100 caracteres)',
				submit:'Solicitar un reembolso',
				upload:'Subir',
		        detal:'Detalles del pedido de reembolso',
		        information: 'Información de reembolso',
		        refundList: 'Lista de reembolsos',
		        refundType: 'Tipo de reembolso',
		        type1: 'Solo reembolso',
		        type2: 'Devolución y reembolso',
		        validateType: 'Por favor, seleccione el tipo de reembolso',
		        reasons: [
		          'Error de compra/Compra múltiple/No quiero',
		          'Reembolso acordado',
		          'Agotado',
		          'No enviado a tiempo',
		          'Otro',
		          'Problema de calidad del producto',
		          'Producto recibido dañado'
		        ]
			},
			trackingDialog: {
				title: 'Ingresar número de seguimiento',
				company: 'Empresa de logística',
				companyPlaceholder: 'Por favor, ingrese el nombre de la empresa de logística',
				trackingNumber: 'Número de seguimiento',
				trackingNumberPlaceholder: 'Por favor, ingrese el número de seguimiento',
				remark: 'Nota',
				remarkPlaceholder: 'Por favor, ingrese detalles, opcional',
				uploadLabel: 'Subir comprobante',
				uploadTip: 'Por favor, suba el comprobante del número de seguimiento, opcional',
				cancel: 'Cancelar',
				confirm: 'Confirmar',
				submitSuccess: 'Enviado con éxito',
				submitFailed: 'Error al enviar',
				validateCompany: 'Por favor, ingrese el nombre de la empresa de logística',
				validateTrackingNumber: 'Por favor, ingrese el número de seguimiento'
			},
			evaluationList: {
				pending: 'Pendiente de evaluación',
				completed: 'Evaluado',
				goEvaluate: 'Evaluar',
				noPendingOrders: 'No hay pedidos pendientes de evaluación',
				noEvaluationRecords: 'No hay registros de evaluación',
				evaluationTime: 'Tiempo de evaluación'
			},
			login:{
				placeEmail:'Por favor, ingrese el correo electrónico',
				placePasd:'Por favor, ingrese la contraseña',
				sign:'INICIAR SESIÓN',
				create:'Crear cuenta',
				forget:'¿Olvidó su contraseña?',
				quick:'Inicio de sesión rápido',
				pasdLogin:'Inicio de sesión con contraseña',
				with:'Iniciar sesión con',
				Pasdagain:'contraseña de nuevo',
				submit:'Enviar',
				next:'Siguiente',
				reset:'RESTABLECER CONTRASEÑA',
				resetDesc:" Por favor, ingrese su correo electrónico para recibir un enlace para restablecer la contraseña. ",
				emailVer:"Verificación de correo electrónico",
				verDesc:'Para la seguridad de su cuenta, verifique su correo electrónico：',
				tourists:'Compra anónima',
				continue:'Continuar',
				phoneVer:'Verificación telefónica',
		        remember: '¿Recordar su contraseña?'
			},
			register:{
				tabNav:[
					{name:'Correo electrónico'},
					{name:'Teléfono'}
				],
				placeEmail:'Por favor, ingrese el correo electrónico',
				placeCode:'Por favor, ingrese el captcha',
				placePhone:'Número de teléfono',
				submit:'Enviar',
				have:'¿Tiene una cuenta?',
				sign:'Iniciar sesión'
			},
			logistics:{
				navTitle:'logística',
				expName:'nombreExp',
				expNo:'noExp',
				title:'Información logística',
				company:'Empresa de logística',
				website:'Sitio web de contacto',
				trackingNo:'Número de seguimiento',
			},
			userIntegral:{
				now:'Tener integral',
				totalInt:'Integral total',
				totalPay:'Consumo',
				freeze:'Congelar integral',
				tabNav:[
					{name:"El detalle"},
					{name:"Ascensión"},
				],
				shopAdd:'Puede ganar puntos por sus compras',
				make:'Agregar',
				empty:'No hay registro'
			},
			replyList: {
				navTitle: 'Lista de evaluaciones'
			},
			wallet: {
				navTitle: 'Lista de evaluaciones',
				all: 'Todo',
				income: 'Revenu',
				spending: 'Depense',
        cumulativeSpending: 'Consumo acumulado',
				tableColumn: {
					type: 'Tipo',
					amount: 'Cantidad',
					time: 'Fecha'
				}
			},
			invoiceList: {
				navTitle: 'Lista de facturas',
				openedCount: 'Factura abierta',
				applyingCount: 'Factura aplicando',
				orderNum: 'Número de pedido',
				applicationTime: 'Tiempo de solicitud',
				tableColumn: {
					info: 'Información de la factura',
					amount: 'Cantidad',
					title: 'Factura',
					type: 'Tipo de factura',
					date: 'Fecha de la factura',
					status: 'Progreso de la factura',
					actions: 'Operación de la factura',
					type1: 'Personal',
					type2: 'Empresa'
				},
				status: {
					0: 'Pendiente de revisión',
					1: 'Aprobado',
					2: 'Rechazado'
				},
				actionBtn: {
					viewInvoice: 'Ver factura',
					orderDetails: 'Detalles del pedido',
					cancel: 'Cancelar solicitud'
				}
			},
			afterSaleDetail: {
				returnType: 'Tipo de devolución',
				consignee: 'Destinatario',
				contact: 'Información de contacto',
				returnAddress: 'Dirección de devolución',
				copy: 'Copiar',
				refundInfo: 'Información de reembolso',
				refundSn: 'Número de reembolso',
				table: {
					info: 'Información de reembolso',
					quantity: 'Cantidad',
					amount: 'Monto de reembolso',
					reason: 'Razón de reembolso'
				}
			}
		},
		store: {
			search: 'búsqueda en la tienda',
			followed: 'Seguido',
			follow: 'seguir',
			storeRating: 'Calificación',
			storeQualification: 'Cualificación',
			storeIntroduction: 'Introducción',
			storeAddress: 'Dirección',
			storePhone: 'Teléfono',
			storeService: 'Contactar al vendedor',
			storeTime: 'Unirse',
			storeName: 'Nombre del comerciante',
			userName:'Nombre de usuario',
			phone: 'Teléfono',
			emil:'correo electrónico',
			code: 'Código',
			getCode: 'Obtener código',
			class:'Clasificación de comerciantes',
			type:'Tipo de tienda',
			place1:'Por favor, cargue las imágenes de la licencia comercial y el certificado de calificación relacionado con la industria',
			place2:'Se pueden cargar hasta 10 imágenes y el formato admite JPG, PNG y JPEG',
			agree:'Leer y aceptar',
			agreement:'Acuerdo de liquidación',
			submit:'Enviar solicitud',
			agreement2:'Acuerdo de entrada de comerciantes',
			Tips1:'¡Felicidades, su información ha sido enviada con éxito!',
			Tips2:'Se espera que la auditoría se complete dentro de los 15 días hábiles, ¡y el servicio al cliente de la plataforma se comunicará con usted a tiempo!',
			Tips3:'Volver a la página de inicio',
			title1:'Liquidación de comerciantes',
			title2:'Ven y únete a nosotros',
			street: 'Calle de tiendas',
			keyword: 'palabra clave',
			merInfo: 'Detalles de la tienda',
			index: 'página de inicio',
			classify: 'clasificación',
			collar: 'Recoger cupones',
			call: 'Servicio',
			people: ' Seguidores',
			delFollow: 'dejar de seguir',
			selfSupport: 'autosoporte',
		      homeNav: [
		        {name: 'página de inicio'},
		        {name: 'clasificación'},
		        {name: 'Recoger cupones'}
		      ]
		}
	},
	message:{
		login:{
			loginLoading:'iniciando sesión',
			getting:'cargando',
			emailEmpty:'Por favor, complete su dirección de correo electrónico',
			correctEmail:'Por favor, complete la dirección de correo electrónico correcta',
			emptyPassword:'Por favor, complete su contraseña',
			againPassword:'Por favor, confirme la contraseña.',
			diffPassword:'Las contraseñas no coinciden',
			emptyPhone:'Por favor, complete su teléfono',
			emptyCaptche:'Por favor, complete su captcha',
			correctCaptche:'Por favor, complete el captcha correcto',
			loginSuccess:'inicio de sesión exitoso',
			resetSuccess:'restablecimiento de contraseña exitoso',
			name:'Por favor, complete su nombre',
			detail:'Por favor, complete su dirección detallada',
			postCode:'Por favor, complete su código postal',
			save:'Es para guardar',
			updateSU:'Modificar el éxito',
			saveSU:'Guardar éxito',
			prompt:'aviso',
			country: 'Seleccione el país',
			confirmDel:'¿Está seguro?',
			logout:'¿Confirmar cierre de sesión?',
			notExist:'La dirección no existe',
			setSu:'Establecer éxito',
			delSU:'Eliminar éxito',
			calSU:'Cancelación exitosa',
			send:'enviar',
			resend:'reenviar',
			remaining:'cd',
			operationSU: 'Operación exitosa',
			loginSure: '¿Desea utilizar esta contraseña para mantener el inicio de sesión después de la modificación?',
			loginFacebook:'Los usuarios actuales no han iniciado sesión en Facebook o en su página web',
		      registerSU:'el inicio de sesión fue exitoso',
		      agreement: 'Por favor, revise el acuerdo de privacidad del usuario',
		      agree: 'He leído y acepto',
		      agreementName: 'Acuerdo de usuario'
		},
		pay:{
			orderFail:'Pagar por el fracaso',
			error:'Faltan parámetros, no se puede ver el estado de pago del pedido',
			errorOrder: 'Falta el número de pedido. No se pueden ver los detalles del pedido'
		},
		orderConfirm:{
			payType:'Por favor, seleccione el método de pago',
			emptyAddress:'Por favor, seleccione la dirección de envío',
			payLoading:'Pagar',
			productInfo: 'Información del producto',
			confirmPay: '¿Está seguro de pagar este pedido?',
			prompt: 'Aviso',
			orderCreateFail: 'Error al crear el pedido',
			orderCreateFailMsg: 'Error al crear el pedido, inténtelo más tarde',
			mercadoMinAmountTip: 'Al usar el pago de Mercado, el monto debe ser superior a 3. Por favor, elija otro método de pago.'
		},
		tips: {
			time: 'Hora de envío',
			adopt:'Aprobado',
			noadopt: 'Auditoría fallida',
			reason: 'razón',
			stay: 'Para ser revisado',
			edit: 'editar',
			see: 'ver',
			again: 'Reenviar',
			shoppingSU: 'El carrito de compras se agregó con éxito',
			addingToCart: 'Agregando al carrito...',
			loding: 'Cargando...',
			selectAddress: 'Seleccionar dirección',
			selectOther: 'Elegir otra dirección',
			surePay: '¿Está seguro de pagar el pedido?',
			sureDel: '¿Está seguro de eliminar este pedido?',
			upPic:'Se pueden cargar hasta 5 copias',
			edidM: 'Haga clic en modificar contraseña',
			sold: 'Vendido',
			changeGoods: 'Por favor, seleccione un artículo',
			picTips: 'El formato de carga es JPG, png',
			noEvaluation: 'no hay comentarios~',
			more: 'mostrar más',
			hide: 'ocultar más',
			noDetal: 'Aún no hay detalles del producto',
			getSU: 'Recibido con éxito',
			browser: 'Debido a la funcionalidad limitada del navegador 360, ¡presione Ctrl+D para recopilar manualmente!',
			nubrowser: 'Su navegador no lo admite, ¡presione Ctrl+D para agregar manualmente!',
			error1: 'Lo sentimos, hubo un error en la página que visitó',
			error2: 'No se pudo cargar',
			error3:'mala solicitud',
			error4:'Por favor, revise su archivo de configuración',
			placeLogin: 'por favor inicie sesión',
			selectSku: 'Por favor, seleccione el artículo',
			noComment: 'Este usuario no ha escrito una reseña',
			getDetailFailed: 'Error al obtener los detalles del producto'
		},
		settled: {
			emptyName:"Por favor, ingrese el nombre de la empresa",
			emptyRealName:"Por favor, ingrese el nombre",
			emptyCaptcha:"Por favor, ingrese el código de verificación",
			emptyCategory:"Por favor, seleccione la categoría de comerciante",
			emptyIsAgree:"Por favor, revise y acepte el acuerdo de liquidación",
			emptyIsPicture:"Por favor, cargue la imagen de calificación",
			appleTips: 'Aún no hay registro de solicitud. Vaya y solicite la admisión'
		},
		common: {
			confirm: 'Confirmar',
			cancel: 'Cancelar'
		}
	},
	router: {
		home: 'Inicio',
		users: 'Centro de Usuario',
		addressList: 'Lista de Direcciones',
		applicationRecord: 'Registro de Solicitud',
		collectionList: 'Lista de Favoritos',
		couponList: 'Lista de Cupones',
		evaluationConfirm: 'Confirmar Evaluación',
		evaluationList: 'Lista de Evaluaciones',
		invoiceList: 'Lista de Facturas',
		merchantSettled: 'Registro de Comerciante',
		orderList: 'Lista de Pedidos',
		afterSale: 'Postventa',
		refundConfirm: 'Confirmar Reembolso',
		refundList: 'Lista de Reembolsos',
		userInfo: 'Información de Usuario',
		wallet: 'Mi Billetera',
		activityList: 'Lista de Actividades',
		goodsSearch: 'Búsqueda de Productos',
		topOne: 'Clasificación',
		goodsDetail: 'Detalle del Producto',
		merchant: 'Comerciante',
		merchantMore: 'Más Comerciantes',
		merchantStreet: 'Calle de Comerciantes',
		merchantCategory: 'Categoría de Comerciante',
		merchantCoupon: 'Cupón de Comerciante',
		merchantHome: 'Página Principal del Comerciante',
		merchantQualification: 'Calificación del Comerciante',
		callbackTwitter: 'Callback de Twitter',
		privacyAgreement: 'Acuerdo de Privacidad',
		about: 'Sobre nosotros',
		contact: 'Contáctenos',
		orderConfirm: 'Confirmar Pedido',
		orderDetail: 'Detalle del Pedido',
		paymentResult: 'Resultado del Pago',
		refundDetail: 'Detalle del Reembolso',
		shoppingCart: 'Carrito de Compras',
		stripePayment: 'Pago con Stripe',
		news: 'Noticias',
		newsDetail: 'Detalle de Noticias',
		trackOrder: 'Rastrear Pedido'
	}
}
